import { describeResource } from '@siteless/resource';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import z from 'zod';
import { thisOscarsYear } from '../../config/constants';

let firestoreTimestampSchema = z.object({
  nanoseconds: z.number(),
  seconds: z.number(),
});

let ceremonyDetailsSchema = z.object({
  ceremonyStartAt: firestoreTimestampSchema.optional(),
  ceremonyStartAtSource: z.string().optional(),
  ceremonyHost: z.string().optional(),
  ceremonyHostSource: z.string().optional(),
  nominationsAnnouncementAt: firestoreTimestampSchema.optional(),
  nominationsAnnouncementAtSource: z.string().optional(),
  shortlistsRevealAt: firestoreTimestampSchema.optional(),
  shortlistsRevealAtSourceOptional: z.string().optional(),
  votingEndsAt: firestoreTimestampSchema.optional(),
  votingEndsAtSourceOptional: z.string().optional(),
});

let objectiveStateSlimSchema = z.object({
  ceremonyStartAt: firestoreTimestampSchema.optional(),
  ceremonyDetails: ceremonyDetailsSchema.optional(),
  isBallotReady: z.boolean().optional(),
  didCeremonyEnd: z.boolean().optional(),
  didCeremonyStart: z.boolean().optional(),
});

function normalizeObjectiveStateSlim(raw: Record<string, unknown>) {
  const rawCeremonyDetails = raw.ceremonyDetails as Record<string, unknown>;
  const ceremonyStartAt = rawCeremonyDetails?.ceremonyStartAt;

  return {
    ...raw,
    ceremonyStartAt,
  };
}

export type ObjectiveStateSlimType = z.infer<typeof objectiveStateSlimSchema>;

let ObjectiveStateSlimResource = describeResource<
  number | undefined,
  ObjectiveStateSlimType
>('ObjectiveStateSlim', {
  get: async (oscarsYear = thisOscarsYear) => {
    let docSnap = await getDoc(doc(database, 'objective_state', String(oscarsYear)));
    let rawData = (docSnap.data() ?? {}) as Record<string, unknown>;

    return objectiveStateSlimSchema.parse(
      normalizeObjectiveStateSlim(rawData),
    );
  },
});

export default ObjectiveStateSlimResource;
